import { lazy } from "react";
import ViewStudentNotification from "@repo/design-system/components/viewStudentNotification/ViewStudentNotification.jsx";

/** Pages */
const Profile = lazy(() => import("../pages/profile/Profile"));
const Settings = lazy(() => import("@gyandiksha/profile/components/StudentSettings"));
const EditProfile = lazy(() => import("../pages/editProfile/EditProfile"));
const Dashboard = lazy(() => import("../pages/dashboard/Dashboard"));
const UIComponents = lazy(() => import("../pages/uiComponents/UIComponents"));
const GridBuilder = lazy(() => import("../pages/uiGridBuilder/UIGridBuilder"));
const UIFormBuilder = lazy(() => import("../pages/uiFormBuilder/UIFormBuilder"));

const ViewStudentNotificationPage = () => (
    <ViewStudentNotification />
);

/** Scholarship */
const Scholarship = lazy(() => import("../pages/scholarship/Scholarship"));
const ApplyScholarship = lazy(() => import("../pages/scholarship/feature/applyScholarship/ApplyScholarship"));
/* My Applications */
const MyApplications = lazy(() => import("../pages/myApplications/MyApplications"));
/* Scholarship Applications
Nodel Officer */
const ScholarshipApplications = lazy(() => import("../pages/scholarshipApplictions/ScholarshipApplications"));
const ScholarshipReview = lazy(() => import("../pages/scholarshipApplictions/feature/scholarshipReview/ScholarshipApplicationReview"));
const AdminScholarship = lazy(() => import("../pages/adminScholarship/AdminScholarship"));
const AddEditScholarship = lazy(() => import("../pages/adminScholarship/feature/addEditScholarship/AddEditScholarship"));

const ComponentNavigation = [

    /** Platform -  Dashboard */
    {
        id: "dashboard", path: "/dashboard", exact: true, title: "",
        component: Dashboard, hasParams: false, text: "Dashboard Page",
    },
    {
        id: "uicomponents", path: "/uicomponents", exact: true, title: "",
        component: UIComponents, hasParams: false, text: "UI Component Page",
    },
    {
        id: "view-student-notification", path: "/view-student-notification", exact: true, title: "",
        component: ViewStudentNotificationPage, hasParams: false, text: "View Student Notifications",
    },

    /** Scholarship */
    {
        id: "adminScholarships", path: "/admin/scholarships", exact: true, title: "",
        component: AdminScholarship, hasParams: false, text: "Scholarship Admin",
    },
    {
        id: "adminScholarships", path: "/admin/scholarships/add", exact: true, title: "",
        component: AddEditScholarship, hasParams: false, text: "Add Scholarship",
    },
    {
        id: "adminScholarships", path: "/admin/scholarships/edit/:id", exact: true, title: "",
        component: AddEditScholarship, hasParams: false, text: "Edit Scholarship",
    },
    {
        id: "scholarship", path: "/scholarship", exact: true, title: "",
        component: Scholarship, hasParams: false, text: "Scholarship",
    },
    {
        id: "scholarship", path: "/scholarship/:path", exact: true, title: "",
        component: ApplyScholarship, hasParams: false, text: "Scholarship",
    },
    {
        id: "myApplications", path: "/my-applications", exact: true, title: "",
        component: MyApplications, hasParams: false, text: "My Applications",
    },
    {
        id: "scholarshipApplications", path: "/scholarship-applications", exact: true, title: "",
        component: ScholarshipApplications, hasParams: false, text: "Scholarship Applications",
    },
    {
        id: "scholarshipApplications", path: "/scholarship-applications/:id", exact: true, title: "",
        component: ScholarshipReview, hasParams: false, text: "Scholarship Review",
    },
    {
        id: "profile", path: "/profile", exact: true, title: "",
        component: Profile, hasParams: false, text: "My Profile",
    },
    {
        id: "edit-profile", path: "/edit-profile", exact: true, title: "",
        component: EditProfile, hasParams: false, text: "Edit Profile",
    },
    {
        id: "settings", path: "/settings", exact: true, title: "",
        component: Settings, hasParams: false, text: "Settings",
    },
    {
        id: "formbuilder", path: "/formbuilder", exact: true, title: "",
        component: UIFormBuilder, hasParams: false, text: "Form Builder",
    },
    {
        id: "gridbuilder", path: "/gridbuilder", exact: true, title: "",
        component: GridBuilder, hasParams: false, text: "Student Attendance",
    },
];

export default ComponentNavigation;
